import React, { useState } from 'react';
import { Button } from 'react-bootstrap';

import {
  GetEstimateByMonthDto,
  GetProjectDto,
  GetUmpPositionDto,
  ResponseError,
} from '../../../common/pokCore/autogenerated/pokApiClient';
import { useTranslation } from '../../../common/hooks/useTranslation';
import { usePokCore } from '../../../common/hooks/usePokCore';
import { responseErrors } from '../../../common/pokCore/validation/responseErrors';

import { UmpImportForm } from './UmpImportForm';

interface UmpImportProps {
  estimateByMonth: GetEstimateByMonthDto;
  project?: GetProjectDto;
  purchaseOnly: boolean;
  refresh(): void;
}

export const UmpImport: React.FC<UmpImportProps> = props => {
  const [show, setShow] = useState(false);
  const { t, tk } = useTranslation('administrationLng');
  const pok = usePokCore();

  const handleClose = () => {
    setShow(false);
    props.refresh();
  };

  const handleShow = async () => {
    setShow(true);
  };

  const importPositionsFromUpm = async (
    positions: GetUmpPositionDto[],
    isPurchaseSameAsSales: boolean,
    purchaserId?: string,
  ) => {
    try {
      const result = await pok.umpImport.importPositionsFromUpm(
        props.estimateByMonth.id,
        isPurchaseSameAsSales,
        positions,
        purchaserId,
      );

      if (result.messages.length > 0) {
        return {
          saved: false,
          errors: [
            `${t(tk.umpImport.umpImportResult, { ok: result.okCount, error: result.errorCount, total: result.okCount + result.errorCount })}:`,
            ...result.messages,
          ],
        };
      }
      setShow(false);
      props.refresh();
      return {
        saved: true,
        errors: [],
      };
    } catch (response) {
      return {
        saved: false,
        errors: await responseErrors(response as ResponseError),
      };
    }
  };

  return (
    <>
      <Button className="mx-2" variant="outline-primary" onClick={handleShow}>
        {t(tk.umpImport.umpImport)}
      </Button>
      {show && props.estimateByMonth && props.project && (
        <UmpImportForm
          estimateByMonth={props.estimateByMonth}
          project={props.project}
          onCompleted={importPositionsFromUpm}
          show={show}
          handleClose={handleClose}
        />
      )}
    </>
  );
};
